module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '	<div id="description_container">	\n		<div id="top_block">\n		';
 if(submitter(true) != ''){ ;
__p += '		\n		<div id="user_info_holder">\n			<div id="user_avatar">\n				<img id="avatar_url_img" src="' +
((__t = ( avatar_url )) == null ? '' : __t) +
'" style="display:none;">\n				<img id="avatar_url_placeholder" style="display:none;">\n			</div>\n			<div id="user_name">\n				' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'\n			</div>\n		</div>\n		';
 };
__p += '\n\n\n		';
 if(currentAlbum.campaign){ ;
__p += '\n			<div id="vote_button_holder">\n				';
 if(!voted()){ ;
__p += '<a href="#" id="vote_button"><span>' +
((__t = ( decode_utf8(getVoteShareText()) )) == null ? '' : __t) +
'</span></a>';
 };
__p += '\n				';
 if(voted()){ ;
__p += '<a href="#" id="vote_button" class="voted">\n					';
 if(!displayOptions.showVoteCount){ ;
__p += '<span>' +
((__t = ( decode_utf8(getVotedText()) )) == null ? '' : __t) +
'</span>';
 };
__p += '\n					';
 if(displayOptions.showVoteCount){ ;
__p += '<span>';
 if(like_count != null && like_count != "null" && like_count){ ;
__p += ' ' +
((__t = ( like_count  )) == null ? '' : __t);
 };
__p += '</span>';
 };
__p += '\n				</a>\n				';
 };
__p += '\n			</div>\n		';
 };
__p += '\n\n		<div id="caption_holder" style="min-height:0px !important;">\n			<p>';
 if (shouldShowCaptions()){;
__p += ' ' +
((__t = ( decode_utf8(getTitle()) )) == null ? '' : __t) +
' ';
 };
__p += '</p>\n		</div>\n\n		<div id="share_holder">\n			<div id="social_holder">\n				<a href="#" id="facebook_share"></a>\n				<a href="#" id="twitter_share"></a>\n				<a href="#" id="pinterest_share"></a>\n				<a href="#" id="tumblr_share"></a>\n			</div>\n		</div>\n	</div>\n		';
  if (hasActionLink()) { ;
__p += '\n				<div id="rich_cta_arrows" style="display:none;">\n				    <div id="cta_arrow_left"></div>\n				    <div id="cta_arrow_right"></div>\n				  </div>\n			';
  if (gon.display_options.rich_action_active) { ;
__p += '\n  				<h1 id="rich_cta_header" style="display:none; opacity:0;">Shop this Look</h1>\n  			';
 } ;
__p += '\n			<ul id="rich_action_wrapper_div">\n\n			</ul>\n		';
 } ;
__p += '\n		<div id="report_powered_holder">\n			<div id="report_button_holder">\n				<a href="https://www.pixlee.com/legal?utm_source=pixlee&utm_medium=photos_powered" target="blank" id="report_button">report</a>\n			</div>\n			<a id="powered_by_desc" href="https://www.pixlee.com/?utm_source=Powered%20by%20Pixlee&utm_medium=widget-lightbox&utm_campaign=Powered%20by%20Pixlee" target="_blank"></a>\n		</div>\n	</div>';

}
return __p
}